import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UserFolderSvg = function UserFolderSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.154 10.309a3.06 3.06 0 0 1 4.321 0 3.04 3.04 0 0 1 0 4.304 3.06 3.06 0 0 1-4.32 0 3.04 3.04 0 0 1 0-4.304m2.16.584c-.417 0-.817.165-1.112.46a1.565 1.565 0 0 0 1.113 2.676c.417 0 .818-.165 1.113-.46a1.565 1.565 0 0 0-1.113-2.676",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.603 2.5H2v19h20V6.19h-9.693zm10.62 17.524h1.296V7.665h-8.826L7.99 3.975H3.481v16.05h5.926v-2.267l.37-.213a9.06 9.06 0 0 1 4.538-1.21 9.06 9.06 0 0 1 4.537 1.21l.37.213zm-4.908-3.689h.001l-.001.738-.001-.738m-3.426 3.69h6.852v-1.403a7.6 7.6 0 0 0-3.425-.811h-.002a7.6 7.6 0 0 0-3.425.811z",
    clipRule: "evenodd"
  }));
};
export var UserFolder = function UserFolder(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UserFolderSvg
  }));
};